import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Datatable from "../../components/Muidatatable/Datatable";
import { configuration } from "../../helper/appconfig";
import toastAlert from "../../helper/ToastAlert/ToastAlert";
import {
    CircularProgress,
    Typography,
    Grid,
    Autocomplete,
    Box,
    TextField,
} from "@mui/material";
import { Link } from "react-router-dom";
import { TableMain } from "../AllUsers/Style";
import { MainCard } from "../../common-styled";
import { MainTitle } from "../CreateUser/Style";
import { handleAuthTokenError } from "../../redux/actions/authActions";
import "../ViewLab/style.css";
import { TableRow, TableCell } from "@material-ui/core";

const GroupTableValue = (data) => [
    {
        name: "Index",
        options: {
            filter: false,
            customBodyRender: (value, tableMeta, updateValue) => {
                if (value) {
                    return (
                        <span
                            className="badge badge-primary"
                            style={{ backgroundColor: "transparent" }}
                        >
                            <div className="table_data table_data_index">
                                <p>{value}</p>
                            </div>
                        </span>
                    );
                }
            },
        },
    },
    {
        name: "Group Name",
        options: {
            filter: true,
            customBodyRender: (value, tableMeta, updateValue) => {
                if (value) {
                    return (
                        <span
                            className="badge badge-primary"
                            style={{ backgroundColor: "transparent" }}
                        >
                            <div className="table_data">
                                <p>{value}</p>
                            </div>
                        </span>
                    );
                }
            },
        },
    },
    {
        name: "Group Id",
        options: {
            filter: true,
            customBodyRender: (value, tableMeta, updateValue) => {
                return (
                    <span
                        className="badge badge-primary"
                        style={{ backgroundColor: "transparent" }}
                    >
                        <div className="table_data">
                            <p>{value}</p>
                        </div>
                    </span>
                );
            },
        },
    },
    {
        name: "Description",
        options: {
            filter: true,
            customBodyRender: (value, tableMeta, updateValue) => {
                return (
                    <span
                        className="badge badge-primary"
                        style={{ backgroundColor: "transparent" }}
                    >
                        <div className="table_data">
                            <p>{value}</p>
                        </div>
                    </span>
                );
            },
        },
    },
];

const AttachedPolicyValue = () => [
    {
        name: "Index",
        options: {
            filter: false,
            customBodyRender: (value) => {
                if (value) {
                    return (
                        <span
                            className="badge badge-primary"
                            style={{ backgroundColor: "transparent" }}
                        >
                            <div className="table_data table_data_index">
                                <p>{value}</p>
                            </div>
                        </span>
                    );
                }
            },
        },
    },
    {
        name: "Policy Name",
        options: {
            filter: true,
            customBodyRender: (value) => {
                if (value) {
                    return (
                        <span
                            className="badge badge-primary"
                            style={{ backgroundColor: "transparent" }}
                        >
                            <div className="table_data">
                                <p>{value}</p>
                            </div>
                        </span>
                    );
                }
            },
        },
    },


    {
        name: "Policy Id",
        options: {
            filter: false,
            customBodyRender: (value) => {
                return (
                    <span
                        className="badge badge-primary"
                        style={{ backgroundColor: "transparent" }}
                    >
                        <div className="table_data">
                            <p>{value}</p>
                        </div>
                    </span>
                );
            },
        },
    },

];

class UserGroups extends Component {
    constructor() {
        super();
        this.state = {
            groupData: [],
            attachedPolicies: [],
            loading: false,
            selectedId: null,
            userData: [],
        };
    }

    componentDidMount() {
        this.setState({
            // loading: true,
        });
    }

    itemArray = () => {
        return [
            {
                name: "Lab Access",
                active: false,
                link: "",
            },
            {
                name: "User Groups",
                active: true,
                link: "",
            },
        ];
    };

    renderGroupData = () => {
        const { groupData } = this.state
        if (groupData?.length) {
            let temp = [];
            groupData?.map((group, idx) =>
                temp.push([
                    idx + 1,
                    group?.GroupName,
                    group?.GroupId,
                    group?.Description,
                ])
            );
            return temp;
        }
    };

    renderAttachedPolicyData = () => {
        if (this?.state?.attachedPolicies?.length) {
            let temp = [];
            this?.state?.attachedPolicies?.map((attachedPolicy, idx) => (
                temp.push([
                    idx + 1,
                    attachedPolicy?.policyName,
                    attachedPolicy?.policyId,

                ])
            ))
            return temp;
        }
    }

    setID = (evt, val) => {
        if (val == null) {
            this.setState({
                selectedId: val,
                loading: false,
                groupData: [],
                attachedPolicies: []
            });
            return;
        }

        this.setState({ selectedId: val, loading: true }, () => {
            this.getMyGroups(val);
            this.getAttachedPolicies(val);
        });
    };


    getFilteredUsers = (evt) => {
        const url = configuration.userList;
        const tokenType = this.props?.authData?.tokenType;
        const idToken = this.props?.authData?.idToken;

        const headers = {
            "Authorization": `${tokenType} ${idToken}`
        }
        let body = {
            "limit": "60",
            "filter": evt.target.value
        }
        axios.post(url, body, { headers })
            .then((response) => {
                console.log(response, "responseFromGetAllUsers")
                this.setState({
                    userData: response.data?.Users
                })
            })
            .catch((error) => {
                console.log(error, "errorFromGetAllUsers")
                let errorMessage = error?.response?.data?.message;
                if (errorMessage === "Unauthorized") {
                    this?.props?.handleAuthTokenError(this.props)
                }
                if (!error.response) {
                    toastAlert("Please check your internet connection.", "error")
                } else {
                    // toastAlert("Something went wrong. Please try again later.")
                    toastAlert(errorMessage ? errorMessage : "Something went wrong. Please try again later.", "error")
                }
                // toastAlert(errorMessage ? errorMessage : "Something went wrong. Please try again later.","error")
            });
    }

    getMyGroups = (data) => {
        const url = configuration.getMyGroups;
        const tokenType = this.props?.authData?.tokenType;
        const idToken = this.props?.authData?.idToken;
        const headers = {
            Authorization: `${tokenType} ${idToken}`,
        };
        const params = {
            emailId: data?.Email
        }

        axios
            .get(url, { headers, params })
            .then((response) => {
                this.setState({
                    groupData: response?.data,
                    loading: false,
                });
            })
            .catch((error) => {
                console.log(error, "errorFromGetMyGroups");
                let errorMessage = error?.response?.data?.message;
                if (errorMessage === "Unauthorized") {
                    this?.props?.handleAuthTokenError(this.props);
                }
                this.setState({
                    loading: false,
                });
                if (!error.response) {
                    toastAlert("Please check your internet connection.", "error");
                } else {
                    toastAlert(
                        errorMessage
                            ? errorMessage
                            : "Something went wrong. Please try again later.",
                        "error"
                    );
                }
            });
    };

    getAttachedPolicies = (data) => {
        const url = configuration.getSingleAttachedPolicy;
        const tokenType = this.props?.authData?.tokenType;
        const idToken = this.props?.authData?.idToken;

        const headers = {
            Authorization: `${tokenType} ${idToken}`,
        };
        const params = {
            Id: data?.userId
        }
        axios
            .get(url, { headers, params })
            .then((response) => {
                this.setState({
                    attachedPolicies: response?.data.attachedPolicies,
                    loading: false,
                });
            })
            .catch((error) => {
                console.log(error, "errorFromGetMyGroups");
                let errorMessage = error?.response?.data?.message;
                if (errorMessage === "Unauthorized") {
                    this?.props?.handleAuthTokenError(this.props);
                }
                this.setState({
                    loading: false,
                });
                if (!error.response) {
                    toastAlert("Please check your internet connection.", "error");
                } else {
                    toastAlert(
                        errorMessage
                            ? errorMessage
                            : "Something went wrong. Please try again later.",
                        "error"
                    );
                }
            });
    };

    render() {
        const {
            loading,
            groupData,
            attachedPolicies,
            selectedId,
            userData
        } = this?.state;

        const groupsOptions = {
            customRowRender: (data, rowIndex) => {
                const groupId = groupData[rowIndex].GroupId;
                const groupName = groupData[rowIndex].GroupName;

                return (
                    <TableRow
                        component={Link}
                        to={{
                            pathname: `/groupPolicies/${groupId}`,
                            state: { groupName },
                        }}
                        key={rowIndex}
                        hover
                    >
                        {data.map((cell, index) => (
                            <TableCell key={index}>{cell}</TableCell>
                        ))}
                    </TableRow>
                );
            },
        };

        const attachedPolicyOptions = {
            customRowRender: (data, rowIndex) => {
                const policyId = attachedPolicies[rowIndex].policyId;
                const policyName = attachedPolicies[rowIndex].policyName;

                return (
                    <TableRow
                        component={Link}
                        to={{
                            pathname: `/viewPolicy/${policyId}`,
                            state: { policyName },
                        }}
                        key={rowIndex}
                        hover
                    >
                        {data.map((cell, index) => (
                            <TableCell key={index}>{cell}</TableCell>
                        ))}
                    </TableRow>
                );
            },
        };

        return (
            <div>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Breadcrumb items={this?.itemArray()} />

                    <Grid item lg={6} sm={12} xs={12} md={6}>
                        <Autocomplete
                            name="selectedId"
                            className='create-policy-autocomplete'
                            value={selectedId}
                            id="tags-outlined"
                            options={userData}
                            size="small"
                            onChange={(event, value) => this.setID(event, value)}
                            getOptionLabel={(option) => option?.Email}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={"Search User"}
                                    placeholder={"Search User"}
                                    onChange={(e) => this.getFilteredUsers(e)}
                                />
                            )}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    sx={{ '& > img': { flexShrink: 0 } }}
                                    {...props}
                                >
                                    {option.Email} (User)
                                </Box>
                            )}
                        />
                    </Grid>
                </Box>

                {/* Group Data Section */}
                {groupData && groupData.length !== 0 ? (
                    <MainCard>
                        <MainTitle>
                            <Typography className="card_title">User Groups</Typography>
                        </MainTitle>
                        <TableMain className="muiMainTable">
                            {loading ? (
                                <Grid mt={5} container style={{ justifyContent: "center" }}>
                                    <CircularProgress style={{ color: "var(--secondary-dark)" }} size={50} />
                                </Grid>
                            ) : (
                                <Datatable
                                    data={this.renderGroupData()}
                                    Table_value={GroupTableValue(groupData)}
                                    options={groupsOptions}
                                />
                            )}
                        </TableMain>
                    </MainCard>
                ) : null}

                {/* Attached Policies Section */}
                {attachedPolicies && attachedPolicies.length !== 0 ? (
                    <MainCard>
                        <MainTitle>
                            <Typography className="card_title">
                                User Attached Policies
                            </Typography>
                        </MainTitle>
                        <TableMain style={{ textAlign: "center" }} className="loader_main">
                            {loading ? (
                                <Grid mt={5} container style={{ justifyContent: "center" }}>
                                    <CircularProgress
                                        style={{ color: "var(--secondary-dark)" }}
                                        size={50}
                                    />
                                </Grid>
                            ) : (
                                <Datatable
                                    data={this.renderAttachedPolicyData()}
                                    Table_value={AttachedPolicyValue(this.openDeletePolicyModal)}
                                    options={attachedPolicyOptions}
                                />
                            )}
                        </TableMain>
                    </MainCard>
                ) : null}

                {/* No Data Message */}
                {(!groupData || groupData.length === 0) && (!attachedPolicies || attachedPolicies.length === 0) && !loading && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '70vh',  
                            height: 'auto',     
                            padding: 2,
                        }}
                    >
                        <Typography variant="h6">Search user to get data</Typography>
                    </Box>
                )}
            </div>

        );
    }
}

const mapStateToProps = (state) => ({
    authData: state.authReducer,
});

export default connect(mapStateToProps, { handleAuthTokenError })(UserGroups);
